var _pattern, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeamlessColorfulSparsePolkaDotPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2560 1600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    width: 300,
    height: 300,
    patternUnits: "userSpaceOnUse",
    id: "a",
    viewBox: "0 -300 300 300",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0-300h300V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8367FF",
    d: "M100-225c0 13.807-11.193 25-25 25s-25-11.193-25-25 11.193-25 25-25 25 11.193 25 25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F00",
    d: "M100-75c0 13.807-11.193 25-25 25S50-61.193 50-75s11.193-25 25-25 25 11.193 25 25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1FF00",
    d: "M250-225c0 13.807-11.193 25-25 25s-25-11.193-25-25 11.193-25 25-25 25 11.193 25 25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F",
    d: "M250-75c0 13.807-11.193 25-25 25s-25-11.193-25-25 11.193-25 25-25 25 11.193 25 25z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h2560v1600H0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeamlessColorfulSparsePolkaDotPattern);
export default __webpack_public_path__ + "static/media/Seamless-Colorful-Sparse-Polka-Dot-Pattern.e967cc5497374bbd5d296e9279230c91.svg";
export { ForwardRef as ReactComponent };